import React from "react";

// Native button semantics, accessible name, and a tooltip for every icon action.
export default function DraftIconButton({ icon: Icon, label, tooltip = label, className = "", spinning = false, ...props }) {
  return <button type="button" className={`draft-icon-button ${className}`} aria-label={label} title={tooltip} {...props}>
    <Icon size={18} strokeWidth={1.8} aria-hidden="true" focusable="false" className={spinning ? "draft-spin" : undefined} />
  </button>;
}